import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import { ConfigurationText } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import MODAL from 'constants/layout/modals'
import { modal } from 'helpers/decorators'

@modal.trigger()
class UserGuideModal extends Component {
  static propTypes = {
    onOpen: PropTypes.func,
    organizationId: PropTypes.number
  }

  render() {
    const { organizationId } = this.props

    return (
      <div>
        <span
          className="link"
          onClick={() => this.props.onOpen(MODAL.SECURITY_POLICY, null, null)}
        >
          <FormattedMessage
            id="label.show_security_and_refund_policy"
            defaultMessage="Show security and refund policy"
          />
        </span>
        <MaterialModal.Body
          id={MODAL.SECURITY_POLICY}
          title="Refund and payment information"
          titleKey="moduleTitle.security_and_refund_policy"
        >
          <MaterialModal.Content noFooter>

            <ConfigurationText
              configKey={CONFIGURATION_KEYS.payFees.id}
              organizationId={organizationId || 1}
              isPublic
            />
            <ConfigurationText
              configKey={CONFIGURATION_KEYS.refundPolicy.id}
              organizationId={organizationId || 1}
              isPublic
            />
            <ConfigurationText
              configKey={CONFIGURATION_KEYS.securityPolicy.id}
              organizationId={organizationId || 1}
              isPublic
            />
          </MaterialModal.Content>
        </MaterialModal.Body>
      </div>
    )
  }
}

export default UserGuideModal
